// src/components/layout/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/layout/Header.module.css';

/**
 * Header component with responsive navigation
 * 
 * @param {Object} props - Component props
 */
export function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  // Toggle navigation menu on mobile
  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  // Close navigation after clicking a link
  const closeNav = () => {
    setIsNavOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <Link to="/" className={styles.logo} onClick={closeNav}>
          Nick Debeurre
        </Link>

        <button 
          className={`${styles.mobileMenuBtn} ${isNavOpen ? styles.open : ''}`} 
          onClick={toggleNav}
          aria-label="Toggle navigation menu"
        >
          <span className={styles.hamburgerLine}></span>
          <span className={styles.hamburgerLine}></span>
          <span className={styles.hamburgerLine}></span>
        </button>

        <nav className={`${styles.nav} ${isNavOpen ? styles.open : ''}`}>
          <Link to="/about" onClick={closeNav} className={styles.navLink}>
            About
          </Link>
          <Link to="/projects" onClick={closeNav} className={styles.navLink}>
            Projects
          </Link>
          <Link to="/blog" onClick={closeNav} className={styles.navLink}>
            Blog
          </Link>
          <Link to="/contact" onClick={closeNav} className={styles.navLink}>
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
}